// The quote drawer. Links marked data-quote-open still go to /quote/
// without JavaScript; here they open the dialog instead, pre-filled with
// the product or service the link is about.
export function initQuote() {
  const dialog = document.querySelector('[data-quote-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const defaults = () => {
    const form = dialog.querySelector('[data-lead-form]');
    return form && {
      type: form.querySelector('[data-subject-type]')?.value ?? '',
      id: form.querySelector('[data-subject-id]')?.value ?? '',
      label: form.querySelector('[data-subject-label]')?.textContent ?? '',
    };
  };
  const initial = defaults();

  const fill = (trigger) => {
    const form = dialog.querySelector('[data-lead-form]');
    if (!form || !initial) return;
    const subject = trigger.dataset.subjectId
      ? { type: trigger.dataset.subjectType, id: trigger.dataset.subjectId, label: trigger.dataset.subjectLabel }
      : initial;
    const set = (sel, v) => { const el = form.querySelector(sel); if (el) el.value = v ?? ''; };
    set('[data-subject-type]', subject.type);
    set('[data-subject-id]', subject.id);
    const label = form.querySelector('[data-subject-label]');
    const wrap = form.querySelector('[data-subject-label-wrap]');
    if (label) label.textContent = subject.label ?? '';
    if (wrap) wrap.hidden = !subject.label;
    const kind = form.querySelector('[data-kind-select]');
    if (kind && trigger.dataset.kind) kind.value = trigger.dataset.kind;
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quote-open]');
    if (trigger && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      fill(trigger);
      dialog.showModal();
      dialog.querySelector('input:not([type=hidden]):not([tabindex="-1"]), select, textarea')?.focus();
      return;
    }
    if (e.target.closest('[data-quote-close]') || e.target === dialog) dialog.close();
  });

  // After a successful send, move focus to the confirmation.
  document.body.addEventListener('htmx:afterSwap', (e) => {
    e.target.querySelector?.('[data-autofocus]')?.focus();
  });
}
